import React from 'react';
import {Typography} from "@mui/joy";
import Box from "@mui/material/Box";
import {Button} from "@mui/material";

interface Props {
    icon?: React.ReactNode;
    title?: string,
    subtitle?: string,
    /** Extra content rendered below the subtitle (e.g. a hint line with a link). */
    extra?: React.ReactNode;
    btnText?: string,
    onClick?: () => void;
    btnIcon?: React.ReactNode;
}

const SearchAssetEmptyView = ({icon, title, subtitle, extra, btnText, onClick, btnIcon}: Props) => {

    return <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '13px',
            padding: '34px',
            width: '100%',
            // Center vertically inside the fixed-height search-step body.
            my: 'auto',
            boxSizing: 'border-box',
        }}
    >
        {icon && <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'text.secondary',
            '& svg': {fontSize: '48px'},
        }}>
            {icon}
        </Box>}
        <Typography level={'titleSmall'} sx={{textAlign: 'center'}}>{title}</Typography>
        <Typography level={'bodySmall'} sx={{textAlign: 'center'}}>{subtitle}</Typography>
        {extra}
        {onClick &&
            <Button startIcon={btnIcon} variant={'outlined'} onClick={onClick}>{btnText}</Button>}
    </Box>
};

export default SearchAssetEmptyView;
